import { DateTime } from "luxon";

export default function formatUrlDate(date: Date) {
  return DateTime.fromJSDate(date, { zone: "UTC" }).toISO({
    suppressSeconds: true,
    suppressMilliseconds: true,
  });
}
